import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomCartStateType {
    valuesUpdated: boolean;
    showModal: boolean;
    cancelAction?: (param: any) => void;
}

export type CustomCartState = Readonly<CustomCartStateType>;

const initialCounterState: CustomCartState = {
    valuesUpdated: false,
    showModal: false,
};

export const customReducerCartReducer = createTypedReducer(initialCounterState, {
    "Custom/CartState/Values": (draft: Draft<CustomCartState>, { valuesUpdated }: { valuesUpdated: boolean }) => ({
        ...draft,
        valuesUpdated,
    }),
    "Custom/CartState/Modal": (
        draft: Draft<CustomCartState>,
        { showModal, cancelAction }: { showModal: boolean; cancelAction?: (param: any) => void },
    ) => ({
        ...draft,
        showModal,
        cancelAction,
    }),
});
